// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3f482ea13d9b3f4aef7c90c3cee4e6e8583d1d67.chunk.js";
};